module.exports = __webpack_public_path__ + "static/img/gov.ceeec68.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/gov.png
// module id = XptI
// module chunks = 1